export const KITS = [
  {
    slug: "hanuman-pooja-kit",
    name: "Hanuman Pooja Kit",
    color: "#E06B22",
    tagline: "Strength. Devotion. Discipline.",
    description: "A complete kit curated for Hanuman puja, Chalisa paath and Tuesday rituals.",
    occasion: "Tuesdays · Hanuman Jayanti · Sundarkand paath",
    image: "/products/hanuman-kit.jpg",
    includes: ["Sindoor (special)", "Kalava", "Ghee Cotton Wicks", "Til oil", "Kapoor", "Agarbatti", "Akshat", "Guide Book"],
    benefits: ["One-box solution for Hanuman puja", "Premium ingredients, authentic ratios", "Includes step-by-step paath guide"],
    howTo: ["Lay out samagri on the puja chowki.", "Begin with sankalp and deepak prajwalan.", "Follow the guide book paath in order."],
  },
  {
    slug: "shani-pooja-kit",
    name: "Shani Pooja Kit",
    color: "#1B2A49",
    tagline: "Patience. Discipline. Justice.",
    description: "Saturday paath kit for Shani Dev with traditional dark blue identity.",
    occasion: "Saturdays · Shani Jayanti · Sade Sati paath",
    image: "/products/shani-kit.jpg",
    includes: ["Til oil", "Black til seeds", "Kalava", "Kapoor", "Iron diya", "Dhoop", "Akshat", "Guide Book"],
    benefits: ["Saturday-ready in one box", "Authentic til oil & seeds", "Includes paath guide"],
    howTo: ["Bathe Shani idol with mustard oil.", "Light iron diya with til oil.", "Recite mantras as per guide."],
  },
  {
    slug: "shivji-pooja-kit",
    name: "Shivji Pooja Kit",
    color: "#1D524D",
    tagline: "Stillness. Power. Grace.",
    description: "Monday & Mahashivratri abhishek kit, calm and dignified.",
    occasion: "Mondays · Mahashivratri · Shravan",
    image: "/products/shivji-kit.jpg",
    includes: ["Bhasma", "Bel-leaf incense", "Kalava", "Chandan Tilak Paste", "Kapoor", "Cotton Wicks", "Akshat", "Guide Book"],
    benefits: ["Abhishek-ready samagri", "Authentic bhasma & chandan", "Includes guide book"],
    howTo: ["Place Shivling on a clean thali.", "Offer abhishek as per guide.", "Conclude with aarti & kapoor."],
  },
  {
    slug: "griha-pravesh-kit",
    name: "Griha Pravesh Kit",
    color: "#D9A036",
    tagline: "A blessing for new beginnings.",
    description: "Complete housewarming kit for a calm, traditional griha pravesh.",
    occasion: "Griha Pravesh · Vastu Shanti · Office openings",
    image: "/products/griha-pravesh-kit.jpg",
    includes: ["Kalash items", "Coconut", "Mango leaves toran", "Havan Samagri", "Kalava", "Chandan", "Kapoor", "Guide Book"],
    benefits: ["Vastu-correct sequencing", "Premium toran & kalash", "Step-by-step paath guide"],
    howTo: ["Set kalash at the entrance.", "Tie mango-leaf toran on the door.", "Perform havan as per guide."],
  },
  {
    slug: "lakshmi-pooja-kit",
    name: "Lakshmi Pooja Kit",
    color: "#8A1A2B",
    tagline: "Prosperity. Abundance. Grace.",
    description: "Diwali & Friday puja kit — curated to invite Lakshmi into the home.",
    occasion: "Diwali · Fridays · Vaibhav Lakshmi Vrat",
    image: "/products/lakshmi-kit.jpg",
    includes: ["Akhand Jyot wicks", "Pure ghee", "Kumkum", "Kalava", "Chandan", "Attar", "Akshat", "Guide Book"],
    benefits: ["Diwali-ready in one box", "Premium chunari & samagri", "Includes paath guide"],
    howTo: ["Set chowki with Lakshmi idol.", "Light akhand jyot at sankalp.", "Follow paath as per guide."],
  },
];

export const getKit = (slug) => KITS.find((k) => k.slug === slug);
